import React, { useState, useEffect, useCallback, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import Modal from 'react-modal';
import * as properties from '../../constants/Properties';
import { setCreateCustomerModal, setCustomerExistsModal } from '../actions/modalActions';
import { toggleKeyboard } from '../../actions/layoutActions';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { saveCustomer } from '../../actions/invoiceActions';
import * as general from '../../constants/General';
import * as resource from '../../constants/Resources';
import { getTranslation } from '../../actions/dataActions';
import * as generalActions from '../../actions/generalActions';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import * as systemSetting from '../../constants/SystemSettings';
import InvoiceCustomerSearchModal from './InvoiceCustomerSearchModal';

function CreateCustomerModal(props) {
  const {
    countries = [],
    customergroups = [],
    labels = [],
    poslabels = [],
    systemSettings = {},
    createCustomerModal,
    setCreateCustomerModal,
    saveCustomer,
    toggleKeyboard,
    getTranslation,
    posId,
  } = props;

  const dispatch = useDispatch();

  const [defaultAllowAfterPayValue, setDefaultAllowAfterPayValue] = useState('');
  const [customerId, setCustomerId] = useState(0);
  const [useIdentificationNumber, setUseIdentificationNumber] = useState(false);
  const [enableCustomerInfoRequired, setEnableCustomerInfoRequired] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [showInvoiceCustomerModal, setShowInvoiceCustomerModal] = useState(false);
  const [invoiceCustomerId, setInvoiceCustomerId] = useState('');
  const [invoiceCustomerName, setInvoiceCustomerName] = useState('');
  const invoiceCustomerIdRef = useRef(invoiceCustomerId);

  useEffect(() => {
    invoiceCustomerIdRef.current = invoiceCustomerId;
  }, [invoiceCustomerId]);

  // Fetch system settings only once
  useEffect(() => {
    let isMounted = true;

    fetch(`${general.API_URL_GET_SYSTEM_SETTING_BY_KEY}DefaultAllowAfterPayValue`)
      .then(response => response.json())
      .then(json => { if (isMounted) setDefaultAllowAfterPayValue(json ? json.Value : 'false'); });

    fetch(`${general.API_URL_GET_SYSTEM_SETTING_BY_KEY}UseIdentificationNumber`)
      .then(response => response.json())
      .then(json => { if (isMounted) setUseIdentificationNumber(json ? json.Value === 'true' : false); });

    fetch(`${general.API_URL_GET_SYSTEM_SETTING_BY_KEY}EnableCustomerInfoRequiredForInvoice`)
      .then(response => response.json())
      .then(json => { if (isMounted) setEnableCustomerInfoRequired(json ? json.Value === 'true' : false); });

    return () => { isMounted = false; };
  }, []);

  // Set selected labels when modal opens or labels change
  useEffect(() => {
    if (createCustomerModal.customerId === 0) {
      setSelectedOptions(poslabels);
    } else if (createCustomerModal.labels && createCustomerModal.labels.length > 0) {
      const filteredArray = labels.filter(itm =>
        createCustomerModal.labels.includes(itm.LabelId)
      );
      setSelectedOptions(filteredArray);
    } else {
      setSelectedOptions([]);
    }
  }, [createCustomerModal.labels, createCustomerModal.customerId, labels, poslabels]);

  useEffect(() => {
    if (createCustomerModal.show && createCustomerModal.customerId === 0) {
      setInvoiceCustomerId('');
      setInvoiceCustomerName('');
      // Update the ref immediately
      invoiceCustomerIdRef.current = '';
    }
  }, [createCustomerModal.show, createCustomerModal.customerId]);

  useEffect(() => {
    if (createCustomerModal.show && createCustomerModal.customerId > 0) {
      invoiceCustomerIdRef.current = invoiceCustomerId;
    }
  }, [createCustomerModal.show, createCustomerModal.customerId, invoiceCustomerId]);

  useEffect(() => {
    if (createCustomerModal.show) {
      invoiceCustomerIdRef.current = invoiceCustomerId;
      if (createCustomerModal.customerId > 0 && createCustomerModal.invoiceCustomerId !== undefined) {
        const invoiceId = createCustomerModal.invoiceCustomerId || '';
        setInvoiceCustomerId(invoiceId);
        invoiceCustomerIdRef.current = invoiceId;
      }
    }
  }, [createCustomerModal.show, createCustomerModal.customerId, createCustomerModal.invoiceCustomerId, invoiceCustomerId]);

  const handleChange = useCallback(e => {
    setSelectedOptions(e || []);
  }, []);

  const showKeyboard = useCallback(
    event => {
      toggleKeyboard(true, `#${event.target.id}`, event.target.name, null, [], null, event.target.value);
    },
    [toggleKeyboard]
  );

  const cancelTap = useCallback(() => {
    setCustomerId(0);
    setCreateCustomerModal(false, 'default');
  }, [setCreateCustomerModal]);

  const setCustomerFromJson = useCallback(
    json => {
      const dateOfBirth = (json.DateOfBirth || '').split('T')[0];
      const customerGroupDateTo = (json.CustomerGroupDateTo || '').split('T')[0];
      $('#Name').val(json.Name || '');
      $('#Badge').val(json.Badge || '');
      $('#Street').val(json.Street || '');
      $('#HouseNumber').val(json.HouseNumber || '');
      $('#ZipCode').val(json.ZipCode || '');
      $('#City').val(json.City || '');
      $('#DateOfBirth').val(dateOfBirth);
      $('#CustomerGroupDateTo').val(customerGroupDateTo);
      $('#TelephoneNumber1').val(json.TelephoneNumber1 || '');
      $('#Email').val(json.Email || '');
      $('#Gender').val(json.Gender || '');
      $('#CountryID').val(json.CountryID || '');
      $('#CustomerGroupId').val(json.CustomerGroupId || '');
      $('#VatNumber').val(json.VatNumber || '');
      $('#GlnNumber').val(json.GlnNumber || '');
      $('#TaxRegistrationNumber').val(json.TaxRegistrationNumber || '');
      $('#AllowAfterPay').prop('checked', json.AllowAfterPay === true);
      $('#InvoiceOnly').prop('checked', json.InvoiceOnly === true);
      if (useIdentificationNumber) {
        $('#IdentificationNumber').val(json.IdentificationNumber || '');
      }
      $('#CustomerNumber').val(json.CustomerNumber || '');

      const newInvoiceCustomerId = json.InvoiceCustomerID || '';
      const newInvoiceCustomerName = json.InvoiceCustomerName || '';

      setInvoiceCustomerId(newInvoiceCustomerId);
      setInvoiceCustomerName(newInvoiceCustomerName);

      // Update the ref immediately
      invoiceCustomerIdRef.current = newInvoiceCustomerId;
      const customerIdVal = parseInt($('#CustomerId').val(), 10) || 0;
      if (json.LabelIDs && json.LabelIDs.length > 0) {
        const filteredArray = labels.filter(itm => json.LabelIDs.includes(itm.LabelId));
        setSelectedOptions(filteredArray);
      } else if (customerIdVal === 0) {
        setSelectedOptions(poslabels);
      } else {
        setSelectedOptions([]);
      }
    },
    [labels, poslabels, useIdentificationNumber]
  );

  const handleExistingCustomerSelect = useCallback(
    (c, json) => {
      const callback = createCustomerModal.callback;
      dispatch(generalActions.loadingEnd());
      if (!c) {
        setCustomerFromJson(json);
      } else {
        const dateOfBirth = (json.DateOfBirth || '').split('T')[0];
        const customerGroupDateTo = (json.CustomerGroupDateTo || '').split('T')[0];
        $('#CustomerId').val(c.CustomerId);
        setCustomerId(c.CustomerId);
        c.Name = json.Name || '';
        c.Badge = json.Badge || '';
        c.Street = json.Street || '';
        c.HouseNumber = json.HouseNumber || '';
        c.ZipCode = json.ZipCode || '';
        c.City = json.City || '';
        c.DateOfBirth = dateOfBirth;
        c.CustomerGroupDateTo = customerGroupDateTo;
        c.IdentifcationNumber = json.IdentifcationNumber || '';
        c.CustomerNumber = json.CustomerNumber || '';
        c.InvoiceCustomerID = json.InvoiceCustomerID || '';

        // Clear invoice customer fields if not present in the new customer
        const newInvoiceCustomerId = json.InvoiceCustomerID || '';
        const newInvoiceCustomerName = json.InvoiceCustomerName || '';

        setInvoiceCustomerId(newInvoiceCustomerId);
        setInvoiceCustomerName(newInvoiceCustomerName);

        // Update the ref immediately
        invoiceCustomerIdRef.current = newInvoiceCustomerId;

        if (json.LabelIDs && json.LabelIDs.length > 0) {
          const filteredArray = labels.filter(itm => json.LabelIDs.includes(itm.LabelId));
          setSelectedOptions(filteredArray);
        } else {
          setSelectedOptions([]);
        }
        saveCustomer(c, null, customer => {
          cancelTap();
          if (callback) callback(customer);
        });
      }
    },
    [createCustomerModal, saveCustomer, setCustomerFromJson, cancelTap, labels, dispatch]
  );

  const readPassportTap = useCallback(() => {
    dispatch(generalActions.loadingStart());
    fetch(`${general.API_URL_GET_CUSTOMER_CARD_DATA}/${posId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Context: 'CreateCustomerModal:readPassportTap',
      },
    })
      .then(response => (response.status !== 200 ? null : response.json()))
      .then(async json => {
        if (!json) return;
        let dateOfBirth = json.DateOfBirth.split('T')[0];
        json.DateOfBirth = dateOfBirth.split('-').reverse().join('/');
        let name = json.Name;
        let identificationnumber = json.IdentificationNumber;
        let customerList = await fetch(
          `${general.API_URL_GET_CUSTOMER_BY_IDENTIFICATIONNUMBER}/${identificationnumber}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Context: 'CreateCustomerModal:readPassportTap',
            },
          }
        );
        let response = await fetch(
          `${general.API_URL_GET_CUSTOMER_BY_NAME_AND_DATE_OF_BIRTH}/${name}/${dateOfBirth}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Context: 'CreateCustomerModal:readPassportTap',
            },
          }
        );
        if (response.status === 200 && customerList.status === 200) {
          let existsJson = await response.json();
          let customerListJson = await customerList.json();

          if (customerListJson.length <= 1) {
            if (customerListJson.length === 1) {
              $('#CustomerId').val(customerListJson[0].CustomerId);
              setCustomerId(customerListJson[0].CustomerId);
              Object.assign(json, customerListJson[0]);
            }
            setCustomerFromJson(json);
          } else if (customerListJson.length > 1) {
            dispatch(
              setCustomerExistsModal(customerListJson, true, c => {
                handleExistingCustomerSelect(c, json);
              })
            );
          } else if (existsJson.length <= 1) {
            if (existsJson.length === 1) {
              $('#CustomerId').val(existsJson[0].CustomerId);
              setCustomerId(existsJson[0].CustomerId);
              Object.assign(json, existsJson[0]);
            }
            setCustomerFromJson(json);
          } else if (existsJson.length > 1) {
            dispatch(
              setCustomerExistsModal(existsJson, true, c => {
                handleExistingCustomerSelect(c, json);
              })
            );
          }
        }
      })
      .finally(() => {
        dispatch(generalActions.loadingEnd());
      });
  }, [dispatch, posId, setCustomerFromJson, handleExistingCustomerSelect]);

  const approveTap = useCallback(async () => {
    const callback = createCustomerModal.callback;

    const response = await fetch(`${general.API_URL_GET_NEW_CUSTOMER_OBJECT}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Context: 'CreateCustomerModal:approveTap',
      },
    });
    const json = await response.json();
    if (!json) return;

    const customerIdVal = parseInt($('#CustomerId').val(), 10) || 0;
    if (customerIdVal >= 0) json.CustomerId = customerIdVal;

    json.Name = $('#Name').val();
    json.Badge = $('#Badge').val();
    json.Gender = $('#Gender').val();
    json.CountryID = $('#CountryID').val();
    json.CustomerGroupId = $('#CustomerGroupId').val();
    json.Street = $('#Street').val();
    json.HouseNumber = $('#HouseNumber').val();
    json.ZipCode = $('#ZipCode').val();
    json.City = $('#City').val();
    json.TelephoneNumber1 = $('#TelephoneNumber1').val();
    json.Email = $('#Email').val();
    json.VatNumber = $('#VatNumber').val();
    json.GlnNumber = $('#GlnNumber').val();
    json.TaxRegistrationNumber = $('#TaxRegistrationNumber').val();
    json.AllowAfterPay = $('#AllowAfterPay').prop('checked');
    json.InvoiceOnly = $('#InvoiceOnly').prop('checked');
    json.CustomerNumber = $('#CustomerNumber').val();
    json.InvoiceCustomerID = invoiceCustomerIdRef.current || '';
    json.LabelIDs = (selectedOptions || []).map(option => option.LabelId);
    const dateOfBirth = $('#DateOfBirth').val();
    const customerGroupDateTo = $('#CustomerGroupDateTo').val();
    json.IdentificationNumber = $('#IdentificationNumber').val().replace(/\D/g, '');
    const fullIdentificationNumber = $('#IdentificationNumber').val();
    const dateOfBirthParts = dateOfBirth.split('/');
    if (dateOfBirthParts.length === 3) {
      const tempDate = new Date(
        +dateOfBirthParts[2],
        dateOfBirthParts[1] - 1,
        +dateOfBirthParts[0]
      );
      const utcDate = new Date(
        Date.UTC(
          tempDate.getFullYear(),
          tempDate.getMonth(),
          tempDate.getDate(),
          0,
          0
        )
      );
      json.DateOfBirth = utcDate;
    } else {
      json.DateOfBirth = dateOfBirth;
    }

    const customerGroupDateToParts = customerGroupDateTo.split('/');
    if (customerGroupDateToParts.length === 3) {
      const tempDate = new Date(
        +customerGroupDateToParts[2],
        customerGroupDateToParts[1] - 1,
        +customerGroupDateToParts[0]
      );
      const utcDate = new Date(
        Date.UTC(
          tempDate.getFullYear(),
          tempDate.getMonth(),
          tempDate.getDate(),
          0,
          0
        )
      );
      json.CustomerGroupDateTo = utcDate;
    } else {
      json.CustomerGroupDateTo = customerGroupDateTo;
    }

    // Identification number validation
    let validIdentificationNumber = false;
    let identification = json.IdentificationNumber;
    if (identification.length === 11) {
      let rrnChecksum = parseInt(identification.slice(-2), 10);
      let partToCalculate = identification.slice(0, 9);
      let rrnInt = parseInt(partToCalculate, 10);
      let checksum = 97 - (rrnInt % 97);
      if (rrnChecksum === checksum) {
        validIdentificationNumber = true;
      } else {
        partToCalculate = '2' + partToCalculate;
        rrnInt = parseInt(partToCalculate, 10);
        checksum = 97 - (rrnInt % 97);
        if (rrnChecksum === checksum) {
          validIdentificationNumber = true;
        }
      }
    }

    // GLN number validation
    let glnNumber = (json.GlnNumber || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    json.GlnNumber = glnNumber;
    if (glnNumber !== '' && glnNumber.length !== 13) {
      dispatch(
        generalActions.setMessageModal(
          true,
          getTranslation(resource.ERROR_INCORRECT_GLNNUMBER)
        )
      );
      return;
    }

    // Tax registration number validation (Belgian KBO checksum)
    let taxRegistrationNumber = (json.TaxRegistrationNumber || '').trim();
    let cleanedTaxRegistrationNumber = taxRegistrationNumber.replace(/\D/g, '');
    const kboPrefix = '0208';

    if (cleanedTaxRegistrationNumber.startsWith(kboPrefix) && cleanedTaxRegistrationNumber.length === 14) {
      cleanedTaxRegistrationNumber = cleanedTaxRegistrationNumber.substring(4);
    }

    json.TaxRegistrationNumber = cleanedTaxRegistrationNumber;
    if (cleanedTaxRegistrationNumber !== '') {
      if (cleanedTaxRegistrationNumber.length !== 10) {
        dispatch(
          generalActions.setMessageModal(
            true,
            getTranslation(resource.ERROR_INCORRECT_TAXREGISTRATIONNUMBER)
          )
        );
        return;
      }

      if (cleanedTaxRegistrationNumber[0] !== '0' && cleanedTaxRegistrationNumber[0] !== '1') {
        dispatch(
          generalActions.setMessageModal(
            true,
            getTranslation(resource.ERROR_INCORRECT_TAXREGISTRATIONNUMBER)
          )
        );
        return;
      }

      const firstDigits = parseInt(cleanedTaxRegistrationNumber.substring(0, 8), 10);
      const checkDigits = parseInt(cleanedTaxRegistrationNumber.substring(8, 10), 10);
      if (Number.isNaN(firstDigits) || Number.isNaN(checkDigits)) {
        dispatch(
          generalActions.setMessageModal(
            true,
            getTranslation(resource.ERROR_INCORRECT_TAXREGISTRATIONNUMBER)
          )
        );
        return;
      }

      const calculatedCheck = 97 - (firstDigits % 97);
      if (calculatedCheck !== checkDigits) {
        dispatch(
          generalActions.setMessageModal(
            true,
            getTranslation(resource.ERROR_INCORRECT_TAXREGISTRATIONNUMBER)
          )
        );
        return;
      }
    }

    // VAT number validation
    let vatNumber = json.VatNumber;
    const disableVatNumberValidation = systemSettings[systemSetting.DISABLE_VATNUMBER_VALIDATION];
    if (!disableVatNumberValidation && vatNumber !== '') {
      const viesValidation = await fetch(
        `${general.API_URL_VALIDATE_VATNUMBER}/${vatNumber}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Context: 'CreateCustomerModal:validateVatnumber',
          },
        }
      );
      const vatnumberValidation = await viesValidation.json();
      if (vatnumberValidation === false) {
        dispatch(
          generalActions.setMessageModal(
            true,
            getTranslation(resource.ERROR_INCORRECT_VATNUMBER)
          )
        );
        return;
      }
    }

    if (
      (validIdentificationNumber && identification.length === 11) ||
      fullIdentificationNumber === ''
    ) {
      if (customerIdVal === 0) {
        let name = json.Name;
        if (identification !== '') {
          const customerList = await fetch(
            `${general.API_URL_GET_CUSTOMER_BY_IDENTIFICATIONNUMBER}/${identification}`,
            {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Context: 'CreateCustomerModal:readPassportTap',
              },
            }
          );
          const customerListJson = await customerList.json();

          if (customerList.status === 200) {
            if (customerListJson.length === 1) {
              $('#CustomerId').val(customerListJson[0].CustomerId);
              setCustomerId(customerListJson[0].CustomerId);
              setCustomerFromJson(customerListJson[0]);
            } else if (customerListJson.length > 1) {
              dispatch(
                setCustomerExistsModal(customerListJson, true, c => {
                  handleExistingCustomerSelect(c, json);
                })
              );
            } else {
              saveCustomer(json, null, customer => {
                cancelTap();
                if (callback) callback(customer);
              });
            }
          }
        } else {
          if (json.DateOfBirth !== '') {
            let date =
              json.DateOfBirth instanceof Date
                ? json.DateOfBirth.toISOString().split('T')[0]
                : json.DateOfBirth;
            const response = await fetch(
              `${general.API_URL_GET_CUSTOMER_BY_NAME_AND_DATE_OF_BIRTH}/${name}/${date}`,
              {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  Context: 'CreateCustomerModal:readPassportTap',
                },
              }
            );
            const existsJson = await response.json();
            if (response.status === 200) {
              if (existsJson.length === 1) {
                $('#CustomerId').val(existsJson[0].CustomerId);
                setCustomerId(existsJson[0].CustomerId);
                setCustomerFromJson(existsJson[0]);
              } else if (existsJson.length > 1) {
                dispatch(
                  setCustomerExistsModal(existsJson, true, c => {
                    handleExistingCustomerSelect(c, json);
                  })
                );
              } else {
                saveCustomer(json, null, customer => {
                  cancelTap();
                  if (callback) callback(customer);
                });
              }
            }
          } else {
            saveCustomer(json, null, customer => {
              cancelTap();
              if (callback) callback(customer);
            });
          }
        }
      } else {
        saveCustomer(json, null, customer => {
          cancelTap();
          if (callback) callback(customer);
        });
      }
    } else {
      dispatch(
        generalActions.setMessageModal(
          true,
          getTranslation(resource.ERROR_INCORRECT_IDENTIFICATIONNUMBER)
        )
      );
    }
  }, [
    createCustomerModal,
    saveCustomer,
    setCustomerFromJson,
    handleExistingCustomerSelect,
    cancelTap,
    selectedOptions,
    systemSettings,
    getTranslation,
    dispatch,
    invoiceCustomerIdRef,
  ]);

  const isNewCustomer = customerId === 0;
  const hideIdentificationNumber = !useIdentificationNumber;
  const enableCustomerInfoRequiredbool = enableCustomerInfoRequired;

  function handleInvoiceCustomerFieldClick() {
    setShowInvoiceCustomerModal(true);
  }

  const handleInvoiceCustomerSelect = useCallback((customer) => {
    if (customer && customer.CustomerId) {
      setInvoiceCustomerId(customer.CustomerId);
      setInvoiceCustomerName(customer.Name);
    } else {
      setInvoiceCustomerId('');
      setInvoiceCustomerName('');
    }
  }, []);

  useEffect(() => {
    window.handleInvoiceCustomerSelect = (customer) => {
      if (customer && customer.CustomerId) {
        setInvoiceCustomerId(customer.CustomerId);
        setInvoiceCustomerName(customer.Name);
      } else {
        setInvoiceCustomerId('');
        setInvoiceCustomerName('');
      }
    };
    return () => { window.handleInvoiceCustomerSelect = undefined; };
  }, []);

  return (
    <div>
      <Modal
        className="createCustomerModal"
        contentLabel=""
        isOpen={createCustomerModal.show}
        style={properties.createCustomerModalStyle}
        id="createCustomerModal"
        ariaHideApp={false} // Remove this if you set Modal.setAppElement in your entry point
      >
        <div className="createCustomerModal_header">
          <div className="header_top" id="createCustomerTitle">
            {getTranslation(isNewCustomer ? resource.NEW_CUSTOMER : resource.EXISTING_CUSTOMER)}
          </div>
        </div>
        <div className="createCustomerModal_content">
          <input id="CustomerId" type="text" style={{ display: 'none' }} name="CustomerId" />
          <div className="row">
            <div className="column">
              <div className="field">
                <label>
                  {getTranslation(resource.NAME)}
                  {enableCustomerInfoRequiredbool ? ' * ' : '  '}
                </label>
                <input
                  id="Name"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.NAME)}
                  placeholder=""
                  autoFocus
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>
                  {getTranslation(resource.STREET)}
                  {enableCustomerInfoRequiredbool ? ' * ' : '  '}
                </label>
                <input
                  id="Street"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.STREET)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>{getTranslation(resource.HOUSE_NUMBER)}</label>
                <input
                  id="HouseNumber"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.HOUSE_NUMBER)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>
                  {getTranslation(resource.ZIPCODE)}
                  {enableCustomerInfoRequiredbool ? ' * ' : '  '}
                </label>
                <input
                  id="ZipCode"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.ZIPCODE)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>
                  {getTranslation(resource.CITY)}
                  {enableCustomerInfoRequiredbool ? ' * ' : '  '}
                </label>
                <input
                  id="City"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.CITY)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>{getTranslation(resource.COUNTRY)}</label>
                <select
                  id="CountryID"
                  className="createCustomerModal_input"
                  name={getTranslation(resource.COUNTRY)}
                  placeholder=""
                >
                  <option key={0} value={0}></option>
                  {countries.map(country => (
                    <option key={country.CountryID} value={country.CountryID}>
                      {country.Translation}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field">
                <label>{getTranslation(resource.TELEPHONE_NUMBER)}</label>
                <input
                  id="TelephoneNumber1"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.TELEPHONE_NUMBER)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>{getTranslation(resource.EMAIL)}</label>
                <input
                  id="Email"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.EMAIL)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>
                  {getTranslation(resource.INVOICE_CUSTOMER)}
                </label>
                <div className="invoice-customer-container">
                  <input
                    id="InvoiceCustomerID"
                    className="createCustomerModal_input"
                    type="text"
                    name="InvoiceCustomerID"
                    placeholder=""
                    value={invoiceCustomerName}
                    readOnly
                    onClick={handleInvoiceCustomerFieldClick}
                  />
                  {invoiceCustomerName && (
                    <button
                      type="button"
                      aria-label="Clear"
                      style={{
                        marginLeft: 4,
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        fontSize: 18,
                        color: '#888',
                      }}
                      onClick={() => {
                        setInvoiceCustomerId('');
                        setInvoiceCustomerName('');
                        invoiceCustomerIdRef.current = '';
                      }}
                      tabIndex={0}
                    >
                      ×
                    </button>
                  )}
                </div>
              </div>
              <div className="field checkbox-field">
                <label style={{ marginRight: 8 }}>{getTranslation(resource.ALLOW_AFTER_PAY)}</label>
                <input
                  id="AllowAfterPay"
                  className="createCustomerModal_input"
                  type="checkbox"
                  name={getTranslation(resource.ALLOW_AFTER_PAY)}
                  placeholder=""
                  style={{ margin: 0 }}
                  defaultChecked={defaultAllowAfterPayValue === 'true'}
                />
              </div>
              <div className="field checkbox-field">
                <label style={{ marginRight: 8 }}>{getTranslation(resource.SHOULD_INVOICE)}</label>
                <input
                  id="InvoiceOnly"
                  className="createCustomerModal_input"
                  type="checkbox"
                  name={getTranslation(resource.SHOULD_INVOICE)}
                  placeholder=""
                  style={{ margin: 0 }}
                  defaultChecked={false}
                />
              </div>
            </div>
            <div className="column">
              <div className="field">
                <label>{getTranslation(resource.BADGE)}</label>
                <input
                  id="Badge"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.BADGE)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>
                  {getTranslation(resource.GENDER)}
                  {enableCustomerInfoRequiredbool ? ' * ' : '  '}
                </label>
                <select
                  id="Gender"
                  className="createCustomerModal_input"
                  name={getTranslation(resource.GENDER)}
                  placeholder=""
                >
                  <option value="M">{getTranslation(resource.MALE)}</option>
                  <option value="V">{getTranslation(resource.FEMALE)}</option>
                  <option value="U">{getTranslation(resource.UNKNOWN)}</option>
                </select>
              </div>
              <div className="field">
                <label>{getTranslation(resource.DATE_OF_BIRTH)}</label>
                <input
                  id="DateOfBirth"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.DATE_OF_BIRTH)}
                  placeholder="dd/MM/yyyy"
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>{getTranslation(resource.VAT_NUMBER)}</label>
                <input
                  id="VatNumber"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.VAT_NUMBER)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>{getTranslation(resource.GLN_NUMBER)}</label>
                <input
                  id="GlnNumber"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.GLN_NUMBER)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
               <div className="field">
                <label>{getTranslation(resource.TAXREGISTRATIONNUMBER)}</label>
                <input
                  id="TaxRegistrationNumber"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.TAXREGISTRATIONNUMBER)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field" hidden={hideIdentificationNumber}>
                <label>{getTranslation(resource.IDENTIFICATION_NUMBER)}</label>
                <input
                  id="IdentificationNumber"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.IDENTIFICATION_NUMBER)}
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>{getTranslation(resource.CUSTOMER_NUMBER)}</label>
                <input
                  id="CustomerNumber"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.CUSTOMER_NUMBER)}
                  placeholder=""
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>{getTranslation(resource.CUSTOMERGROUP)}</label>
                <select
                  id="CustomerGroupId"
                  className="createCustomerModal_input"
                  name={getTranslation(resource.CUSTOMERGROUP)}
                  placeholder=""
                >
                  <option key={0} value={0}></option>
                  {customergroups.map(customergroup => (
                    <option key={customergroup.CustomerGroupId} value={customergroup.CustomerGroupId}>
                      {customergroup.Description}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field">
                <label>{getTranslation(resource.CUSTOMER_GROUP_DATE_TO)}</label>
                <input
                  id="CustomerGroupDateTo"
                  className="createCustomerModal_input"
                  type="text"
                  name={getTranslation(resource.CUSTOMER_GROUP_DATE_TO)}
                  placeholder="dd/MM/yyyy"
                  onClick={showKeyboard}
                />
              </div>
              <div className="field">
                <label>Labels</label>
                <div className="createCustomerModal_input">
                  <Select
                    className="createCustomerModal_input"
                    multi={true}
                    value={selectedOptions}
                    id="Labels"
                    options={labels}
                    onChange={handleChange}
                    placeholder=""
                    autosize={false}
                    valueKey="LabelId"
                    labelKey="Description"
                  />
                </div>
              </div>
              <div className="field">
                <label>{props.getTranslation(resource.EINVOICE_ACTIVE)}</label>
                <input id="EInvoiceActive" className="createCustomerModal_input" type="checkbox" name={props.getTranslation(resource.EINVOICE_ACTIVE)} placeholder="" defaultChecked={false} disabled />
              </div>
            </div>
          </div>
        </div>
        <div className="createCustomerModal_footer">
          <button className="btnCancel" onClick={cancelTap}>
            {getTranslation(resource.CANCEL)}
          </button>
          <button className="btnReadCard" onClick={readPassportTap}>
            {getTranslation(resource.READPASSPORT)}
          </button>
          <button className="btnApprove" onClick={approveTap}>
            {getTranslation(resource.SAVE)}
          </button>
        </div>
      </Modal>
      <InvoiceCustomerSearchModal
        isOpen={showInvoiceCustomerModal}
        onClose={() => setShowInvoiceCustomerModal(false)}
        onSelectCustomer={handleInvoiceCustomerSelect}
      />
    </div>
  );
}

CreateCustomerModal.propTypes = {
  setCreateCustomerModal: PropTypes.func.isRequired,
  saveCustomer: PropTypes.func.isRequired,
  toggleKeyboard: PropTypes.func.isRequired,
  getTranslation: PropTypes.func.isRequired,
  createCustomerModal: PropTypes.object.isRequired,
  posId: PropTypes.any,
  countries: PropTypes.array,
  customergroups: PropTypes.array,
  labels: PropTypes.array,
  poslabels: PropTypes.array,
  systemSettings: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    createCustomerModal: state.modalState.createCustomerModal,
    posId: state.generalState.posId,
    countries: state.generalState.countries,
    customergroups: state.generalState.customergroups,
    labels: state.generalState.labels.all,
    poslabels: state.generalState.labels.posLabels,
    systemSettings: state.generalState.systemSettings,
  };
}

export default connect(mapStateToProps, {
  setCreateCustomerModal,
  saveCustomer,
  toggleKeyboard,
  getTranslation,
})(CreateCustomerModal);


// WEBPACK FOOTER //
// src/modal/components/CreateCustomerModal.jsx